import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import useWindowSize from 'hooks/use-windowSize';

import ExploreCareerCard from 'components/pages/career/explorecareercard/ExploreCareerCard';

import classes from './ContentCareerPaths.module.scss';

const ContentCareerPaths = ({ careerPaths }) => {
    const { mobileDevice, tabletDevice } = useWindowSize();
    return (
        <div className={classes['wrapper']}>
            <h3 className="text-2xl font-bold mb-4">This course is included in these career paths</h3>
            <p>
                Discover tailored career paths designed to help you grow in the pharmaceutical industry.
                Whether you're just starting out or looking to specialize,
                find the roles, skills, and learning steps that align with your goals.
            </p>
            <Swiper
                slidesPerView={mobileDevice ? 1.1 : tabletDevice ? 1.5 : 1.4}
                // spaceBetween={-200}   
                style={{ padding: '20px' }}             
                modules={[Pagination]}
                dir="rtl"
                >
                {careerPaths.map((careerPath, index) => (
                    <SwiperSlide style={{ height: 'auto', overflow: 'visible' }} key={index}>
                        <div className={classes['card-wrapper']}>
                            <ExploreCareerCard key={index} career={careerPath} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>


        </div>
    );
};

export default ContentCareerPaths;